const axios = require("axios");

const axiosFeedbackInstance = axios.create({
    baseURL: process.env.FEEDBACK_BASE_URL,
    // withCredentials: true,

    // // HTTP authentication
    // auth: {
    //     username: process.env.FEEDBACK_HTTP_USER,
    //     password: process.env.FEEDBACK_HTTP_PASSWORD,
    // },

    // API authentication
    headers: {
        'key': process.env.FEEDBACK_API_KEY,
        'secret': process.env.FEEDBACK_API_SECRET,
    },
});

module.exports = axiosFeedbackInstance;
